import {Spinner, SpinnerSize} from '@fluentui/react';

export default function LoadState() {
  return (
      <Spinner size={SpinnerSize.large} label={"Loading the data..."}></Spinner>
  );
}
